module.exports = __webpack_public_path__ + "img/bg_大师分排行@2x.1e9d0ad1.png";